/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [":host{display:flex;flex-grow:1;justify-content:space-between}:host .app-icon-size-small{font-size:13px;line-height:17px}:host app-button:last-child{align-self:flex-end}app-spinner{padding-right:7px}"];
export { styles as styles };
